'use client';

import type React from 'react';
import { useRef } from 'react';
import { useIsTextTruncated } from '@/lib/hooks/useIsTextTruncated';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/lib/ui-kit/tooltip';

interface TruncatedTitleProps {
  children: string;
  className?: string;
  as?: 'p' | 'span' | 'h2' | 'h3' | 'h4';
}

export function TruncatedTitle({ children, className, as: Tag = 'p' }: TruncatedTitleProps) {
  const ref = useRef<HTMLElement>(null);
  const isTruncated = useIsTextTruncated(ref as React.RefObject<HTMLElement>);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {/* @ts-expect-error polymorphic ref */}
          <Tag ref={ref} className={className}>
            {children}
          </Tag>
        </TooltipTrigger>
        {isTruncated && (
          <TooltipContent className="max-w-[280px] border-v2-border">
            <span className="text-[13px] leading-[1.5] text-v2-text-primary">{children}</span>
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
}
